import { Component } from 'react';
import { Switch, Route } from 'react-router';
import './App.scss';

import AuthorizeRoute from './components/api-authorization/AuthorizeRoute';
import ApiAuthorizationRoutes from './components/api-authorization/ApiAuthorizationRoutes';
import { ApplicationPaths } from './components/api-authorization/ApiAuthorizationConstants';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { PermissionFailed } from './components/PermissionFailed';
import { EndUserLicenceAgreementData } from './components/EndUserLicenceAgreement';
import { PrivacyPolicyData } from './components/PrivacyPolicy';
import { TaskFollowUpJobEnquiryData } from './components/TaskFollowUpJobEnquiry';
import { TaskFollowUpQuoteData } from './components/TaskFollowUpQuote';
import { TaskFollowUpGoAheadData } from './components/TaskFollowUpGoAheadForm';
import { TaskFollowUpPrepaidPaymentData } from './components/TaskFollowUpPrepaidPayment';
import { TaskCheckJobCompleteData } from './components/TaskCheckJobComplete';
import { TaskChargeCreditCardData } from './components/TaskChargeCreditCardOverhire';
import { TaskData } from './components/Tasks';
import JobSearchData from './components/JobSearch';
import { JobReportViewerData } from './components/JobReportViewer';
import { JobData } from './components/Job';
import JobsRequiringPaymentData from './components/JobsRequiringPayment';
import JobPaymentData from './components/JobPayment';
import { NewJobData } from './components/NewJob';
import { ScheduleDayMapData } from './components/ScheduleDayMap';
import { ScheduleNewData } from './components/ScheduleNew';
import { ScheduleData } from './components/Schedule';
import ScheduleTiltCraneData from './components/ScheduleTiltCrane';
import { AllocateMapData } from './components/AllocateMap';
import { AllocateData } from './components/AllocateScreen';
import { AllocateDatabaseData } from './components/AllocateScreenDatabase';
import { RunSheetData } from './components/RunSheet';
import { RunSheetDriverUpdateData } from './components/RunSheetDriverUpdate';
import { AdminListData } from './components/AdminLists';
import { AdminPriceListData } from './components/AdminPriceLists';
import AdminPriceListSetWeeksData from './components/AdminPriceListSetWeeks';
import AdminPriceListEpaData from './components/AdminPriceListEpa';
import AdminPriceListPumpAndCleanData from './components/AdminPriceListPumpAndClean';
import AdminPriceListEventData from './components/AdminPriceListEvent';
import AdminPriceListCustomData from './components/AdminPriceListCustom';
import { AdminPriceListKwikstageData } from './components/AdminPriceListsKwikstage';
import AdminPriceListTowerData from './components/AdminPriceListsTower';
import AdminPriceListSettingsData from './components/AdminPriceListsSettings';
import AdminPriceListPowerPoleConnectionData from './components/AdminPriceListPowerPoleConnection';
import AdminPriceListFencingData from './components/AdminPriceListsFencing';
import AdminPriceListFencingCustomData from './components/AdminPriceListsFencingCustom';
import AdminReckonData from './components/AdminReckonData';
import AdminSurchargeData from './components/AdminSurcharge';
import { PublicHolidayData } from './components/AdminPublicHolidays';
import { ShutdownPeriodData } from './components/AdminShutdownPeriods';
import { ItemFormulaData } from './components/AdminItemFormulas';
import { ItemPhotoData } from './components/AdminItemPhoto';
import { ReportJobKpisData } from './components/ReportJobKpis';
import { ReportItemsOnHireSummaryData } from './components/ReportItemsOnHireSummary';
import ReportItemsOnHireData from './components/ReportItemsOnHire';
import { ReportItemsOnHireByDateData } from './components/ReportItemsOnHireByDate';
import ReportPrepaidHireEndingData from './components/ReportPrepaidHireEnding';
import { ReportJobQuoteData } from './components/ReportJobQuote';
import { ReportListData } from './components/Reports';
import ReportTruckChecksGroupedData from './components/ReportTruckChecksGrouped';
import { ReportTruckChecksData } from './components/ReportTruckChecks';
import { ReportJobChecksData } from './components/ReportJobChecks';
import { ReportJobQuoteSummaryData } from './components/ReportJobQuoteSummary';
import { ReportViewerData } from './components/ReportViewer';
import { ReportDeletedJobsData } from './components/ReportDeletedJobs';
import ReportSalesByProductData from './components/ReportSalesByProduct';
import ReportSalesByBranchSummaryData from './components/ReportSalesByBranchSummary';
import ReportSalesByBranchAndProductGroupSummaryData from './components/ReportSalesByBranchAndProductGroupSummary';
import ReportJobSummaryByProductGroupData from './components/ReportJobSummaryByProductGroup';
import ReportCustomerGateCodesData from './components/ReportCustomerGateCodes';
import ReportPowerPolesScheduledData from './components/ReportPowerPolesScheduled';
import ReportCustomersLockedData from './components/ReportCustomersLocked';
import ReportJobsAwaitingPaymentData from './components/ReportJobsAwaitingPayment';
import ReportPowerPolesOnHireData from './components/ReportPowerPolesOnHire';
import ReportConditionData from './components/ReportCondition';
import ReportFencingPickedUpData from './components/ReportFencingPickedUp';
import ReportFencingSummaryData from './components/ReportFencingSummary';
import ReportCustomerEmailsData from './components/ReportCustomerEmails';
import ReportCamerasOnHireData from './components/ReportCamerasOnHire';
import ReportEventJobSummaryData from './components/ReportEventJobSummary';
import ReportCustomerPricelistData from './components/ReportCustomerPricelist';
import ReportInvoicesSentToReckonData from './components/ReportInvoicesSentToReckon';
import ReportPrepaidInvoicesSentData from './components/ReportPrepaidInvoicesSent';
import ReportCsrSalesSummaryData from './components/ReportCsrSalesSummary';
import ReportEpaJobsData from './components/ReportEpaJobs';
import { CustomerSearchData } from './components/CustomerSearch';
import CustomerData from './components/Customer';
import { InvoicingData } from './components/Invoicing';
import { InvoiceData } from './components/Invoice';
import { SendInvoicesData } from './components/InvoicesToSend';
import InvoiceBatchData from './components/InvoiceBatch';
import InvoiceCreditData from './components/InvoiceCredits';
import { UserSearchData } from './components/UserSearch';
import { UserData } from './components/User';
import { CalculatorData } from './components/Calculator';
import QuickBooksRedirect from './components/quickbooksredirect';
import { DriverIncidentReportData } from './components/DriverIncidentReport';
import { DriverJobsData } from './components/DriverJobs';
import DriverJobsTomorrowData from './components/DriverJobsTomorrow';
import { TruckChecklistData } from './components/TruckCheck';
import { TruckToolChecklistData } from './components/TruckToolCheck';
import { DriverJobsTeamData } from './components/DriverJobsTeam';
import SchedulePickupData from './components/SchedulePickup';
import AdminTrucksData from './components/AdminTrucks';
import AdminSystemFilesData from './components/AdminSystemFiles';
import ItemTaskData from './components/ItemTasks';
import ReckonRedirectData from './components/ReckonRedirect';
import CustomerAddData from './components/CustomerAdd';
import AllocateMapDunnyData from './components/AllocateMapDunny';
import ScheduleEventData from './components/ScheduleEvent';

export default class App extends Component {
  static displayName = App.name;

  render () {
    return (
        <Layout>
            <Switch>
                <AuthorizeRoute exact path={'/'} component={Home} />
                <AuthorizeRoute path='/tasks/followupjobenqiry/:id' component={TaskFollowUpJobEnquiryData} />
                <AuthorizeRoute path='/tasks/followupquote/:id' component={TaskFollowUpQuoteData} />
                <AuthorizeRoute path='/tasks/followupgoahead/:id' component={TaskFollowUpGoAheadData} />
                <AuthorizeRoute path='/tasks/followupprepaidpayment/:id' component={TaskFollowUpPrepaidPaymentData} />
                <AuthorizeRoute path='/tasks/checkjobcomplete/:id' component={TaskCheckJobCompleteData} />
                <AuthorizeRoute path='/tasks/chargecreditcard/:id' component={TaskChargeCreditCardData} />
                <AuthorizeRoute path='/tasks' component={TaskData} />
                <AuthorizeRoute path='/jobsearch' component={JobSearchData} />
                <AuthorizeRoute path='/job/:id/report/:name/:param1?' component={JobReportViewerData} />
                <AuthorizeRoute path='/job/:id/payment' component={JobPaymentData} />
                <AuthorizeRoute path='/job/:id/:files?' component={JobData} />
                <AuthorizeRoute path='/newjob/:typeId/:copyId?' component={NewJobData} />
                <AuthorizeRoute path='/jobsrequiringpayment' component={JobsRequiringPaymentData} />
                <AuthorizeRoute path='/itemtasks' component={ItemTaskData} />
                <AuthorizeRoute path='/schedulenew/map/:scheduleBranchId/:scheduleDate' component={ScheduleDayMapData} />
                <AuthorizeRoute path='/schedulenew' component={ScheduleNewData} />
                <AuthorizeRoute path='/schedule/:id?' component={ScheduleData} />
                <AuthorizeRoute path='/scheduletiltcrane' component={ScheduleTiltCraneData} />
                <AuthorizeRoute path='/scheduleevent' component={ScheduleEventData } />
                <AuthorizeRoute path='/schedulepickup' component={SchedulePickupData} />
                <AuthorizeRoute path='/allocate/map/:scheduleDate' component={AllocateMapData} />
                <AuthorizeRoute path='/allocate/googlemap/:scheduleDate/:scheduleBranchId/:itemTypeGroupId' component={AllocateMapDunnyData} />
                <AuthorizeRoute path='/allocate' component={AllocateData} />
                <AuthorizeRoute path='/allocatedatabase' component={AllocateDatabaseData} />
                <AuthorizeRoute path='/runsheet' component={RunSheetData} />
                <AuthorizeRoute path='/runsheetdriver' component={RunSheetDriverUpdateData} />
                <AuthorizeRoute path='/adminlists' component={AdminListData} />
                <AuthorizeRoute path='/pricelists' component={AdminPriceListData} />
                <AuthorizeRoute path='/pricelistsetweeks' component={AdminPriceListSetWeeksData} />
                <AuthorizeRoute path='/pricelistepa' component={AdminPriceListEpaData } />
                <AuthorizeRoute path='/pricelistpumpclean' component={AdminPriceListPumpAndCleanData} />
                <AuthorizeRoute path='/pricelistfencingcustom' component={AdminPriceListFencingCustomData } />
                <AuthorizeRoute path='/pricelistfencing' component={AdminPriceListFencingData } />
                <AuthorizeRoute path='/pricelistevent' component={AdminPriceListEventData} />
                <AuthorizeRoute path='/pricelistcustom' component={AdminPriceListCustomData } />
                <AuthorizeRoute path='/pricelistkwikstage' component={AdminPriceListKwikstageData} />
                <AuthorizeRoute path='/pricelisttowers' component={AdminPriceListTowerData } />
                <AuthorizeRoute path='/pricelistpowerpoleconnection' component={AdminPriceListPowerPoleConnectionData} />
                <AuthorizeRoute path='/pricelistsettings' component={AdminPriceListSettingsData } />
                <AuthorizeRoute path='/publicholidays' component={PublicHolidayData} />
                <AuthorizeRoute path='/shutdownperiods' component={ShutdownPeriodData} />
                <AuthorizeRoute path='/itemformulas' component={ItemFormulaData} />
                <AuthorizeRoute path='/itemphoto' component={ItemPhotoData} />
                <AuthorizeRoute path='/trucks' component={AdminTrucksData} />
                <AuthorizeRoute path='/reckondata' component={AdminReckonData} />
                <AuthorizeRoute path='/systemfiles' component={AdminSystemFilesData} />
                <AuthorizeRoute path='/surcharges' component={AdminSurchargeData } />

                <AuthorizeRoute path='/report/:name/:param1/:param2/:param3/:param4/:param5' component={ReportViewerData} />
                <AuthorizeRoute path='/reports/jobkpis' component={ReportJobKpisData} />
                <AuthorizeRoute path='/reports/itemsonhiresummary' component={ReportItemsOnHireSummaryData} />
                <AuthorizeRoute path='/reports/itemsonhirebydate' component={ReportItemsOnHireByDateData} />
                <AuthorizeRoute path='/reports/itemsonhire' component={ReportItemsOnHireData} />
                <AuthorizeRoute path='/reports/prepaidhireending' component={ReportPrepaidHireEndingData } />
                <AuthorizeRoute path='/reports/jobquote' component={ReportJobQuoteData} />
                <AuthorizeRoute path='/reports/deletedjobs' component={ReportDeletedJobsData} />
                <AuthorizeRoute path='/reports/csrsalessummary' component={ReportCsrSalesSummaryData } />
                <AuthorizeRoute path='/reports/salesbyproduct' component={ReportSalesByProductData} />
                <AuthorizeRoute path='/reports/salesbybranchsummary' component={ReportSalesByBranchSummaryData} />
                <AuthorizeRoute path='/reports/salesbybranchandproductgroupsummary' component={ReportSalesByBranchAndProductGroupSummaryData } />
                <AuthorizeRoute path='/reports/jobsummarybyproductgroup' component={ReportJobSummaryByProductGroupData } />
                <AuthorizeRoute path='/reports/truckchecksgrouped' component={ReportTruckChecksGroupedData} />
                <AuthorizeRoute path='/reports/truckchecks' component={ReportTruckChecksData} />
                <AuthorizeRoute path='/reports/jobchecks' component={ReportJobChecksData} />
                <AuthorizeRoute path='/reports/jobquotesummary' component={ReportJobQuoteSummaryData} />
                <AuthorizeRoute path='/reports/customeremails' component={ReportCustomerEmailsData } />
                <AuthorizeRoute path='/reports/customergatecodes' component={ReportCustomerGateCodesData} />
                <AuthorizeRoute path='/reports/camerasonhire' component={ReportCamerasOnHireData} />
                <AuthorizeRoute path='/reports/powerpolesscheduled' component={ReportPowerPolesScheduledData} />
                <AuthorizeRoute path='/reports/condition' component={ReportConditionData } />
                <AuthorizeRoute path='/reports/customerslocked' component={ReportCustomersLockedData} />
                <AuthorizeRoute path='/reports/jobsawaitingpayment' component={ReportJobsAwaitingPaymentData} />
                <AuthorizeRoute path='/reports/invoicessenttoreckon' component={ReportInvoicesSentToReckonData } />
                <AuthorizeRoute path='/reports/powerpolesonhire' component={ReportPowerPolesOnHireData} />
                <AuthorizeRoute path='/reports/fencingpickedup' component={ReportFencingPickedUpData } />
                <AuthorizeRoute path='/reports/fencingsummary' component={ReportFencingSummaryData } />
                <AuthorizeRoute path='/reports/eventjobsummary' component={ReportEventJobSummaryData} />
                <AuthorizeRoute path='/reports/customerspricelist' component={ReportCustomerPricelistData } />
                <AuthorizeRoute path='/reports/prepaidinvoicessent' component={ReportPrepaidInvoicesSentData} />
                <AuthorizeRoute path='/reports/epaJobs' component={ReportEpaJobsData } />
                <AuthorizeRoute path='/reports' component={ReportListData} />
                
                <AuthorizeRoute path='/customersearch' component={CustomerSearchData} />
                <AuthorizeRoute path='/customer/:id?' component={CustomerData} />
                <AuthorizeRoute path='/customeradd' component={CustomerAddData} />
                
                <AuthorizeRoute path='/invoices' component={InvoicingData} />
                <AuthorizeRoute path='/invoice/:id?' component={InvoiceData} />
                <AuthorizeRoute path='/sendinvoices' component={SendInvoicesData} />
                <AuthorizeRoute path='/invoicebatch' component={InvoiceBatchData} />
                <AuthorizeRoute path='/invoicecredit' component={InvoiceCreditData} />
                <AuthorizeRoute path='/reckonredirect' component={ReckonRedirectData} />
                <AuthorizeRoute path='/quickbooksredirect' component={QuickBooksRedirect} />
                <AuthorizeRoute path='/usersearch' component={UserSearchData} />
                <AuthorizeRoute path='/user/:id?' component={UserData} />

                <AuthorizeRoute path='/driverjobs' component={DriverJobsData} />
                <AuthorizeRoute path='/drivertomorrowjobs' component={DriverJobsTomorrowData} />
                <AuthorizeRoute path='/drivertruckcheck/:truckId' component={TruckChecklistData} />
                <AuthorizeRoute path='/drivertoolcheck/:truckId/:timeofday' component={TruckToolChecklistData} />
                <AuthorizeRoute path='/driverteam/:truckId' component={DriverJobsTeamData} />
                <AuthorizeRoute path='/driverincident/:truckId' component={DriverIncidentReportData} />

                <AuthorizeRoute path='/calculator' component={CalculatorData} />
                <AuthorizeRoute path='/accessdenied' component={PermissionFailed} />

                <Route path='/eula' component={EndUserLicenceAgreementData} />
                <Route path='/privacypolicy' component={PrivacyPolicyData} />

                <Route path={ApplicationPaths.ApiAuthorizationPrefix} component={ApiAuthorizationRoutes} />
            </Switch>
        </Layout>
    );
  }
}